"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OsmosisQueriesImpl = exports.OsmosisQueries = void 0;
const fee_tokens_1 = require("./txfees/fee-tokens");
const spot_price_by_denom_1 = require("./txfees/spot-price-by-denom");
const base_denom_1 = require("./txfees/base-denom");
exports.OsmosisQueries = {
    use() {
        return (queriesSetBase, kvStore, chainId, chainGetter) => {
            return {
                osmosis: new OsmosisQueriesImpl(queriesSetBase, kvStore, chainId, chainGetter),
            };
        };
    },
};
class OsmosisQueriesImpl {
    constructor(_, kvStore, chainId, chainGetter) {
        this.queryTxFeesFeeTokens = new fee_tokens_1.ObservableQueryTxFeesFeeTokens(kvStore, chainId, chainGetter);
        this.queryTxFeesSpotPriceByDenom = new spot_price_by_denom_1.ObservableQueryTxFeesSpotPriceByDenom(kvStore, chainId, chainGetter);
        this.queryTxFeesBaseDenom = new base_denom_1.ObservableQueryTxFeesBaseDenom(kvStore, chainId, chainGetter);
    }
}
exports.OsmosisQueriesImpl = OsmosisQueriesImpl;
//# sourceMappingURL=queries.js.map